import { FaCompass } from "react-icons/fa";

const Compass = ({ globalRefs, mapbearing }) => {
    const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;

    return (
        <button
            type="button"
            aria-label="Reset compass to north"
            title="Reset compass to north"
            onClick={() => polygonCustomLayerRef.current?.cameraFlyToNorth()}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, width: '100%', minHeight: 34, border: '1px solid #cbd7d3', borderRadius: 6, background: '#fff', color: '#245c50', fontSize: 12, cursor: 'pointer' }}
        >
            <FaCompass style={{ transform: `rotate(${135 + mapbearing}deg)` }} aria-hidden="true" size={17} />
            Reset compass
        </button>
    );
};

export default Compass;
